import { Form, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import { validateSomething } from "../../Form/Validations";
import LoadingDialog from "../../Utils/LoadingDialog";
import { useMemo, useRef, useState } from "react";
import { DavisMigrationDialog } from "./DavisMigrationDialog";
import RestAPI from "@aws-amplify/api-rest";
import InputTextPrime from "../../PrimeComponents/InputTextPrime";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import ButtonPrime from "../../PrimeComponents/ButtonPrime";

const DavisLoginForm = ({ handleSubmit, errors, values, setFieldValue, touched, t, setFieldTouched}) => {
    return (
        <div id="extFormContentDavis">
            <Form id="davis_login_form" onSubmit={handleSubmit}>
                <div className="col-12 col-md-12">
                    <label className="boldie" name="sectorDavis">
                        API Key
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    <InputTextPrime
                        name="api_key"
                        value={values.api_key}
                        placeholder="API Key"
                        onChange={e => {setFieldValue("api_key", e?.target?.value); setFieldTouched("api_key", true);}}
                    />
                </div>
                {
                    touched.api_key && errors.api_key &&
                <div className="mb-2 col-12 d-block">
                    <div className="alert alert-warning m-0" role="alert">API Key: {t(errors.api_key)}</div>
                </div>
                }
                <div className="row linea-formulario" />
                <div className="col-12 col-md-12">
                    <label className="boldie" name="sectorDavis">
                        Secret Key
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    <InputTextPrime
                        name="secret_key"
                        value={values.secret_key}
                        placeholder="Secret Key"
                        onChange={e => {setFieldValue("secret_key", e?.target?.value); setFieldTouched("secret_key", true);}}
                    />
                </div>
                {
                    touched.secret_key && errors.secret_key &&
                <div className="mb-2 col-12 d-block">
                    <div className="alert alert-warning m-0" role="alert">Secret Key: {t(errors.secret_key)}</div>
                </div>
                }
                {
                    errors.login &&
                <div className="mb-2 col-12 d-block">
                    <div className="alert alert-warning m-0" role="alert">{t("login.defaultError")}: {t(errors.login)}</div>
                </div>
                }
            </Form>
        </div>
    );
};

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: () => {
        return {
            secret_key: null,
            api_key: null,
        };
    },
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values) => {
        const errors = {};
        if (values) {
            for (const field of Object.keys(values)) {
                if (["secret_key", "api_key"].includes(field)) {
                    const er = validateSomething(values[field]);
                    if (er !== undefined) errors[field] = er;
                }
            }
        }
        return errors;
    },
    handleSubmit: (values, { props }) => {
        props.submit(values);
    }
})(DavisLoginForm);


const DavisLoginDialog = ({ dialogState, setDialogState, setContador, farmId }) => {
    const { t, i18n } = useTranslation();
    const [forceLoading, setForceLoading] = useState(false);
    const [davisMigrationData, setDavisMigrationData] = useState(false);
    const formikRef = useRef(null);
    const buttons = useMemo(() => {
        return [
            {
                buttonModel:{
                    cssClass: "e-primary",
                    isPrimary: true,
                    content: t("external.next"),
                },
                click: async () => {
                    formikRef.current.submitForm();
                }
            },
            {
                buttonModel:{
                    cssClass: "e-flat",
                    content: t("forms.cancel"),
                },
                click: () => {
                    formikRef.current.resetForm();
                    setDialogState({ visible: false });
                }
            }
        ];
    }, [t, setDialogState]);

    const submit = async (values) => {
        setForceLoading(true);
        try {
            const endpoint = `/external/${farmId}/davis-credentials`;
            const body = { secretKey: values.secret_key, apiKey: values.api_key, locale: i18n.language };
            const davisData = await RestAPI.post("apiAdminDropControl", endpoint, { body });
            setDavisMigrationData({
                visible: true,
                // state related to davis case
                apiKey: values.api_key,
                secretKey: values.secret_key,
                davisStations: davisData.stations,
                sensorTypes: davisData.sensorTypes,
                nodoId: dialogState?.nodoId
            });
            setDialogState((state) => ({ ...state, visible: false }));
        } catch (error) {
            if (error.response?.status === 401){
                formikRef.current.setErrors({ login: "external.incorrectDavisKeys" });
            } else {
                formikRef.current.setErrors({ login: "external.error-sign-in" });
            }
        }
        setForceLoading(false);
    };

    const footerContent = (
        <div>
            <Divider />
            {buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );
    return (
        <div id='davisLogin'>
            <Dialog
                visible={dialogState.visible}
                closable
                draggable={false}
                style={{width:"500px"}}
                baseZIndex={1040}
                footer={footerContent}
                onHide={() => {setDialogState({ visible: false }); formikRef.current.resetForm();}}
                header={t("external.migrateToV2")}
            >
                <div id="containerDavisLogin">
                    {forceLoading && <LoadingDialog extraClasses="fixMaxHeight" appendTo="self" /> }
                    <FormikForm
                        innerRef={formikRef}
                        edit
                        t={t}
                        submit={submit}
                    />
                    {
                        davisMigrationData.visible &&
                        <DavisMigrationDialog
                            dialogState={davisMigrationData}
                            setDialogState={setDavisMigrationData}
                            setContador={setContador}
                            farmId={farmId}
                            values={formikRef?.current?.values}
                        />
                    }
                </div>
            </Dialog>
        </div>
    );
};

export { DavisLoginDialog };
